import { render, staticRenderFns } from "./basse-header.vue?vue&type=template&id=02482dc7"
import script from "./basse-header.vue?vue&type=script&lang=js"
export * from "./basse-header.vue?vue&type=script&lang=js"
import style0 from "./basse-header.vue?vue&type=style&index=0&id=02482dc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports